import React from "react";
import { Link } from "react-router-dom";
import { Clock, Beer, Flame } from "lucide-react";

const DIFFICULTY_COLOR = {
  facil: "text-[#00FF66]",
  intermedio: "text-[#FEBA01]",
  hardcore: "text-[#FF3333]",
};

export default function RouteCard({ route }) {
  const stops = route.venue_ids?.length || 0;
  return (
    <Link
      to={`/rutas/${route.id}`}
      data-testid={`route-card-${route.id}`}
      className="group block bg-[#1A1A1A] border-2 border-[#1A1A1A] hover:border-[#FEBA01] overflow-hidden hover-lift"
    >
      <div className="relative aspect-[16/9] overflow-hidden bg-[#0A0A0A]">
        {route.cover_image && (
          <img
            src={route.cover_image}
            alt={route.name}
            className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 transition-all duration-500"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {route.is_official && (
            <span className="bg-[#FEBA01] text-black font-display text-xs uppercase px-2 py-1">
              Top Kiltro
            </span>
          )}
          {route.difficulty && (
            <span className={`bg-black border border-current ${DIFFICULTY_COLOR[route.difficulty] || "text-[#A3A3A3]"} font-mono text-[10px] uppercase tracking-widest px-2 py-1 flex items-center gap-1`}>
              <Flame size={10} /> {route.difficulty}
            </span>
          )}
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="font-display text-2xl uppercase leading-none tracking-tight text-white group-hover:text-[#FEBA01] transition-colors">
            {route.name}
          </h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-[#A3A3A3] line-clamp-2">{route.description}</p>
        <div className="mt-3 flex items-center gap-4 font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">
          <span className="flex items-center gap-1"><Beer size={12} /> {stops} paradas</span>
          {route.duration_hours && (
            <span className="flex items-center gap-1"><Clock size={12} /> {route.duration_hours}h</span>
          )}
        </div>
      </div>
    </Link>
  );
}
